import { useMemo, useContext } from 'react';
import { PageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import { IFilterSet, IFilterItem } from '@/creditflowresearch/ui/common/hooks/filters/useFilterButtons';

const mapFilterToFilterItem = (filter: {
  id: string,
  abbreviation: string,
  queryName?: string,
  isActive: boolean,
  disabled?: boolean,
  tooltip?: string | React.ReactNode,
}): IFilterItem => ({
  id: filter.id,
  abbreviation: filter.abbreviation,
  queryName: filter.queryName,
  isActive: filter.isActive,
  disabled: filter.disabled,
  tooltip: filter.tooltip,
});

const createFilterSet = (
  key: string,
  filters: Array<{
    id: string,
    abbreviation: string,
    queryName?: string,
    isActive: boolean,
    disabled?: boolean,
    tooltip?: string | React.ReactNode,
  }>,
): IFilterSet => ({
  key,
  items: filters.map(mapFilterToFilterItem),
});

export const useDefaultFilterSet = (): IFilterSet[] => {
  const context = useContext(PageFiltersContext);
  const productFilters = context?.productFilters || [];
  const regionFilters = context?.regionFilters || [];

  return useMemo(() => [
    createFilterSet('regions', regionFilters),
    createFilterSet('products', productFilters),
  ], [productFilters, regionFilters]);
};
